import { render, staticRenderFns } from "./WeaponSelect.vue?vue&type=template&id=268ca61a&scoped=true&"
import script from "./WeaponSelect.vue?vue&type=script&lang=js&"
export * from "./WeaponSelect.vue?vue&type=script&lang=js&"
import style0 from "./WeaponSelect.vue?vue&type=style&index=0&id=268ca61a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268ca61a",
  null
  
)

export default component.exports